import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTwitter, FaFacebookF } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);

  const openDeliveryModal = () => {
    setShowDeliveryModal(true);
  };

  const closeDeliveryModal = () => {
    setShowDeliveryModal(false);
  };

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            
            {/* Company Section */}
            <div className="footer-section company-section">
              <div className="footer-logo">
                <img src="/assets/logo-color.svg" alt="Randevu345" className="footer-logo-img" />
              </div>
              <p className="footer-description">
                Türkiye'nin en gelişmiş salon yönetim sistemi. Randevu yönetiminden 
                finansal analize kadar salon işletmeciliğinin her detayını profesyonel 
                şekilde yönetin.
              </p>
              <div className="footer-social">
                <a href="https://www.instagram.com/randevu345" className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="social-icon" />
                  Instagram
                </a>
                <a href="https://www.facebook.com/randevu345" className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaFacebookF className="social-icon" />
                  Facebook
                </a>
                <a href="https://twitter.com/randevu345" className="social-link" target="_blank" rel="noopener noreferrer">
                  <FaTwitter className="social-icon" />
                  Twitter
                </a>
              </div>
            </div>

            {/* Product Section */}
            <div className="footer-section">
              <h4 className="footer-title">Ürün</h4>
              <div className="footer-links">
                <Link to="/features" className="footer-link">Özellikler</Link>
                <Link to="/pricing" className="footer-link">Fiyatlar</Link>
              </div>
            </div>



            {/* Demo Request Section */}
            <div className="footer-section">
              <h4 className="footer-title">Demo Talebi</h4>
              <div className="demo-section">
                <p className="demo-description">
                  Ücretsiz demo için bizimle iletişime geçin
                </p>
                <Link to="/contact" className="demo-btn">Demo İste</Link>
              </div>
            </div>

            {/* Customer Service Section */}
            <div className="footer-section">
              <h4 className="footer-title">Müşteri Hizmetleri</h4>
              <div className="customer-service">
                <div className="phone-contact">
                  <a href="tel:+908503070345" className="phone-number">
                    0850 307 0 <span className="highlight-345">345</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact & Download Section */}
            <div className="footer-section contact-section">
              <h4 className="footer-title">İletişim</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <div className="contact-info">
                    <span className="contact-label">E-posta</span>
                    <a href="mailto:randevu@345.com.tr" className="contact-value">randevu@345.com.tr</a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div className="contact-info">
                    <span className="contact-label">Telefon</span>
                    <a href="tel:+908503070345" className="contact-value">
                      0850 307 0 <span className="highlight">345</span>
                    </a>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <div className="contact-info">
                    <span className="contact-label">Adres</span>
                    <span className="contact-value">
                      Yakuplu Mah. Hürriyet Bulvarı<br />
                      Skyport Residence No:1 D:75<br />
                      Beylikdüzü, İstanbul
                    </span>
                  </div>
                </div>
              </div>

              <div className="footer-download">
                <h5 className="download-title">Mobil Uygulamayı İndirin</h5>
                <div className="download-buttons">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.randevu345.app" 
                    className="download-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/assets/googleplay.svg" alt="Google Play'den İndirin" />
                  </a>
                  <a 
                    href="https://apps.apple.com/tr/app/randevu345/id6743093049" 
                    className="download-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/assets/appstore.svg" alt="App Store'dan İndirin" />
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-bottom-left">
              <p>&copy; {currentYear} Randevu345. Tüm hakları saklıdır.</p>
            </div>
            <div className="footer-bottom-center">
              <div className="footer-legal">
                <a href="https://345.com.tr/privacy" className="legal-link" target="_blank" rel="noopener noreferrer">Gizlilik Politikası</a>
                <a href="https://345.com.tr/privacy" className="legal-link" target="_blank" rel="noopener noreferrer">Kullanım Şartları</a>
                <button onClick={openDeliveryModal} className="legal-link legal-button">Teslimat ve İade</button>
                <a href="https://345.com.tr/privacy" className="legal-link" target="_blank" rel="noopener noreferrer">KVKK</a>
              </div>
            </div>
            <div className="footer-bottom-right">
              <div className="payment-partner">
                <img src="/assets/iyzico.png" alt="İyzico Güvenli Ödeme" className="iyzico-logo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delivery Modal */}
      {showDeliveryModal && (
        <div className="delivery-modal-overlay" onClick={closeDeliveryModal}>
          <div className="delivery-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delivery-modal-header">
              <h2>Teslimat ve İade Şartları</h2>
              <button className="delivery-modal-close" onClick={closeDeliveryModal}>×</button>
            </div>
            <div className="delivery-modal-content">
              <div className="delivery-section">
                <h3>1. Teslimat Koşulları</h3>
                <ul>
                  <li>Satın alınan tüm ürünler dijital içerik ve hizmet niteliğindedir.</li>
                  <li>Ödeme işleminin başarıyla tamamlanmasının ardından, kullanıcıya web tabanlı randevu yazılımı paneline erişim sağlanır.</li>
                  <li>Erişim bilgileri, kullanıcı tarafından kayıt sırasında oluşturulan e-posta adresine veya kullanıcı paneli üzerinden sağlanır.</li>
                  <li>Fiziksel bir teslimat söz konusu değildir.</li>
                </ul>
              </div>

              <div className="delivery-section">
                <h3>2. Teslim Süresi</h3>
                <ul>
                  <li>Dijital ürünlere erişim, ödeme onayını takiben anında ya da en geç 24 saat içinde aktif hale getirilir.</li>
                  <li>Teknik bir aksaklık durumunda destek ekibimiz en kısa sürede çözüm sunar.</li>
                </ul>
              </div>

              <div className="delivery-section">
                <h3>3. İade ve Cayma Hakkı</h3>
                <ul>
                  <li>Satışı yapılan ürün dijital içerik olduğundan, ürüne erişim sağlandıktan sonra iade veya iptal mümkün değildir.</li>
                  <li>Bu durum, 6502 sayılı Tüketicinin Korunması Hakkında Kanun'un 15. maddesi gereği, tüketicinin cayma hakkı dışındadır.</li>
                  <li>Ancak ürünle ilgili bir teknik sorun yaşanması durumunda, kullanıcı destek ekibimize başvurarak çözüm talep edebilir.</li>
                </ul>
              </div>

              <div className="delivery-section">
                <h3>4. Ücretsiz Deneme / Demo Hizmeti</h3>
                <ul>
                  <li>Yazılımımızın belirli fonksiyonları için ücretsiz demo talep etme imkânı sunulmaktadır. Böylece kullanıcı, satın almadan önce ürünü deneyimleyebilir.</li>
                  <li>Detaylı bilgi için bizimle iletişime geçiniz.</li>
                </ul>
              </div>

              <div className="delivery-section">
                <h3>5. İletişim Bilgileri</h3>
                <p>Herhangi bir soru, talep veya teknik destek için bizimle aşağıdaki kanallardan iletişime geçebilirsiniz:</p>
                <ul>
                  <li>E-posta: randevu@345.com.tr</li>
                  <li>Telefon: +90 850 307 0 345</li>
                  <li>WhatsApp: +90 850 307 0 345</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer; 